<template>
  <div class="bottomBar">
    <div class="bottomMenuWrap">
      <div class="leftIcon">
        <i class="el-icon-help"></i>
      </div>
      <div class="midWrap">
        <div class="midInfo">
          场景选择
          <i class="el-icon-more"></i>
        </div>
      </div>
      <div class="rightBtn" @click="showHidePanoTip()">
        <i class="el-icon-view"></i>
        隐藏场景
      </div>
    </div>
    <div class="bottomMenuScrollWrap">
      <div class="scrollWrap">
        <el-scrollbar class="page-scroll">
          <div class="bottomMenuContent">
            <div class="leftBottom">
              <draggable v-model="resInfos.panos" @update="datadragEnd" :options="{animation:500}">
                <transition-group>
                  <div
                    class="panoItem"
                    v-for="(item, i ) in resInfos.panos"
                    :key="item.physicalFile.id"
                  >
                    <div :class="['topWrap',nowPanoItemIndex === i?'active':'']">
                      <img :src="item.physicalFile.thumbnailUrl" @click="changePano(i)" />
                      <div class="editbtn" @click="showEditOptions(i)">
                        <i class="el-icon-more"></i>
                        <div :class="['editOptions',nowEditOptionsNum === i?'active':'']">
                          <div @click="showRenameTip(i)">重命名</div>
                          <div @click="deletePanoItem(i)">删除</div>
                          <div @click="changeThumBPic(i)">替换封面</div>
                        </div>
                      </div>
                    </div>
                    <div class="name">{{item.physicalFile.fileName}}</div>
                  </div>
                </transition-group>
              </draggable>
            </div>
            <div class="panoList_add" @click="showAddPanoList()">
              <img src="images/addArrow.png" alt />
              添加场景
            </div>
            <my-database v-if="dialog" :type="type" :closeFunc="close" :submitFunc="add"></my-database>
          </div>
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>
<style scoped>
.bottomBar {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 150px;
  flex: 0 0 150px;
  /* z-index:10000; */
}
.bottomMenuWrap {
  position: relative;
  border-color: #4b4b4b #000 #000 #4b4b4b;
  border-style: solid;
  border-width: 1px;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 35px;
  flex: 0 0 35px;
  background-color: #2c2c2c;
  box-sizing: border-box;
}
.bottomMenuWrap .leftIcon {
  position: absolute;
  left: 10px;
  height: 35px;
  font-size: 25px;
  vertical-align: middle;
  cursor: pointer;
}
.bottomMenuWrap .leftIcon i {
  line-height: 35px;
}
.bottomMenuWrap .midWrap {
  position: absolute;
  height: 35px;
  left: 50px;
}
.bottomMenuWrap .midWrap .midInfo {
  height: 35px;
  line-height: 35px;
  width: 140px;
  background-color: gray;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
}
.bottomMenuWrap .midWrap .midInfo i {
  cursor: pointer;
  margin-left: 10px;
}
.bottomMenuWrap .rightBtn {
  height: 25px;
  line-height: 25px;
  width: 110px;
  background-color: gray;
  border-radius: 2px 2px;
  position: absolute;
  right: 20px;
  top: 5px;
  font-size: 14px;
  cursor: pointer;
}
.bottomMenuWrap .rightBtn i {
  margin-right: 10px;
}
.bottomMenuScrollWrap {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  /* overflow-y: hidden; */
  position: relative;
  border-color: #4b4b4b #000 #000 #4b4b4b;
  border-style: solid;
  border-width: 1px;
  display: -webkit-box;
  display: -ms-flexbox;
}
.scrollWrap {
  position: relative;
  width: calc(100vw - 300px);
  height: 100%;
  overflow-y: hidden;
  overflow-x: auto;
}
.bottomMenuContent {
  position: relative;
  display: flex;
  -webkit-box-direction: normal;
  -webkit-box-orient: horizontal;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
  height: 110px;
  padding-top: 8px;
}
.bottomMenuContent .panoList_add {
  -webkit-box-orient: vertical;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 70px;
  flex: 0 0 70px;
  height: 70px;
  color: #aaa;
  border: 1px dotted #777;
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-direction: normal;
}
.bottomMenuContent .panoList_add img {
  width: 18px;
  height: 18px;
  margin-bottom: 10px;
}

.bottomMenuContent .leftBottom {
  width: auto;
  height: 100px;
  position: relative;
}
.bottomMenuContent .leftBottom > div {
  width: auto;
  height: 100px;
  position: relative;
}
.bottomMenuContent .leftBottom > div > span {
  position: relative;
  display: flex;
  -webkit-box-direction: normal;
  -webkit-box-orient: horizontal;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
  height: 100px;
}
.bottomMenuContent .panoItem {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 70px;
  flex: 0 0 70px;
  position: relative;
  margin-right: 10px;
  margin-left: 10px;
  color: #aaa;
  font-size: 12px;
}
.bottomMenuContent .panoItem .topWrap {
  position: relative;
  width: 70px;
  height: 70px;
  margin-bottom: 8px;
  background-color: #4b4b4b;
  -webkit-box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.7);
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.7);
  cursor: pointer;
}
.bottomMenuContent .topWrap.active {
  border: 2px solid #fbd14b;
}
.bottomMenuContent .panoItem .topWrap img {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.bottomMenuContent .panoItem .topWrap .editbtn {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 20px;
  height: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  cursor: pointer;
}
.bottomMenuContent .panoItem .topWrap .editbtn i {
  font-size: 15px;
  line-height: 20px;
  text-align: center;
}
.bottomMenuContent .editbtn .editOptions {
  background-color: #fff;
  -webkit-box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.5);
  border-radius: 3px;
  padding: 5px 5px;
  position: absolute;
  right: -60px;
  top: -50px;
  z-index: 99;
  display: none;
  font-size: 12px;
  line-height: 14px;
}
.bottomMenuContent .editbtn .editOptions.active {
  display: block;
}
.bottomMenuContent .editbtn .editOptions div {
  padding: 3px 0;
  color: #333;
  cursor: pointer;
  text-align: center;
}
.bottomMenuContent .editOptions div:hover {
  color: blue;
}
.bottomMenuContent .panoItem .name {
  width: 70px;
  text-align: center;
  cursor: default;
  line-height: 16px;
  font-size: 12px;
  white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
</style>
<script>
import MyDatabase from '../database.vue'
import draggable from 'vuedraggable'
export default {
  name: '',
  components: {
    MyDatabase: MyDatabase,
    draggable
  },
  props: ['resInfos', 'nowPanoItemIndex'],
  computed: {
    getPanoInfos: {
      get() {
        var m = []
        for (var i = 0; i < this.resInfos.panos.length; i++) {
          console.log(i)
          m.push(this.resInfos.panos[i])
        }
        return m
      },
      set(arr) {
        this.resInfos.panos = arr
      }
    }
  },
  data() {
    return {
      dialog: false,
      type: '1',
      nowEditOptionsNum: -1,
      EditOptionsIsShow: false
    }
  },
  created() {
    // console.log(this.panoInfos)
  },
  mounted() {},
  methods: {
    datadragEnd(evt) {
      evt.preventDefault()
      console.log('拖动前的索引 :' + evt.oldIndex)
      console.log('拖动后的索引 :' + evt.newIndex)
      this.sortPanos(this.resInfos.panos)
    },
    sortPanos(arr) {
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i
      }
    },
    showAddPanoList() {
      this.dialog = true
    },
    changePano(num) {
      this.$parent.hasInit = false
      this.$parent.changePanoMat(num)
    },
    showHidePanoTip() {
      this.$msgbox({
        title: '请选择需要隐藏的全景图',
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true
      })
        .then(({ value }) => {
          this.$message({
            type: 'success',
            message: '全景图隐藏成功'
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          })
        })
    },
    showEditOptions(num) {
      if (!this.EditOptionsIsShow) {
        this.nowEditOptionsNum = num
        this.EditOptionsIsShow = true
      } else {
        this.nowEditOptionsNum = -1
        this.EditOptionsIsShow = false
      }
    },
    showRenameTip(num) {
      this.$prompt('全景图重命名', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(({ value }) => {
          this.$message({
            type: 'success',
            message: '你的新名称是: ' + value
          })
          this.resInfos.panos[num].physicalFile.fileName = value
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          })
        })
    },
    deletePanoItem(num) {
      if (this.resInfos.panos.length >= 2) {
        this.$confirm(
          '此操作会将场景' +
            this.resInfos.panos[num].physicalFile.fileName +
            '下所有设置也都删除., 是否继续?',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
          .then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.resInfos.panos.splice(num, 1)
            // let pano =
            //this.resInfos = JSON.parse(JSON.stringify(this.resInfos));
            //this.resInfos.panos = json;
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      } else {
        this.$message({
          type: 'warning',
          message: '至少保留一张全景图'
        })
      }
    },
    close() {
      this.dialog = false
    },
    add(item) {
      console.log(this.resInfos)
      for (var i = 0; i < item.length; i++) {
        var id = item[i].id
        var num = this.resInfos.panos.find(function(elem) {
          console.log(elem.physicalFile.id)
          return elem.physicalFile.id === id
        })
        if (num === undefined) {
          var data = {
            fovDefault: 0,
            fovMax: 0,
            fovMin: 0,
            id: '00000000-0000-0000-0000-000000000000',
            lat: 0,
            lon: 270,
            posX: null,
            posY: null,
            posZ: null,
            sceneID: this.resInfos.id,
            screenPosX: null,
            screenPosY: null,
            status: 1,
            v_High: 0,
            v_Low: 0,
            sort: 0,
            hotPointlist: [],
            physicalFile: {
              createTime: item[i].createTime,
              fileFormat: item[i].fileFormat,
              fileName: item[i].fileName,
              filePath: item[i].filePath,
              fileSize: item[i].fileSize,
              hashValue: item[i].hashValue,
              id: item[i].id,
              status: item[i].status,
              thumbnailUrl: item[i].thumbnailUrl,
              type: item[i].type
            }
          }
          this.$set(this.resInfos.panos, this.resInfos.panos.length, data)
          this.sortPanos(this.resInfos.panos)
        }
      }
    }
  }
}
</script>
